import { useEffect, useRef } from 'react';
import isNil from 'lodash-es/isNil';

export function usePrevious<T extends unknown>(value: T): T | undefined {
  const ref = useRef<T>();
  const prevRef = useRef<T>();
  useEffect(() => {
    if (isNil(ref.current) || ref.current !== value) {
      prevRef.current = ref.current;
      ref.current = value;
    }
  });
  return prevRef.current;
}
